import { ChevronDown } from 'lucide-react'

export default function FilterSelect({ value, onChange, children, className = '', ...props }) {
    return (
        <div className={`relative inline-block ${className}`}>
            <select
                value={value}
                onChange={onChange}
                className="appearance-none w-full bg-white dark:bg-zinc-950 text-black dark:text-white border-2 border-black dark:border-white pl-4 pr-9 py-2 font-mono text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-accent cursor-pointer"
                {...props}
            >
                {children}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-current" />
        </div>
    )
}
